module.exports = __webpack_public_path__ + "static/media/red_back.b27beff2.png";